<div class="filters-toolbar">
  <div class="filters-section">
    <kendo-floatinglabel text="Tier">
    <kendo-dropdownlist
      [data]="tiers"
      class="tier-dropdown"
      [(ngModel)]="selectedTier"
      textField="name"
      valueField="id"
      (ngModelChange)="setDefaultState()"
    >
      <ng-template kendoDropDownListValueTemplate let-dataItem>
        <span class="selected-tier">
          <fa-icon
            class="lock-icon"
            *ngIf="dataItem?.isLocked ?? false"
            [icon]="['fas', 'lock']"
          ></fa-icon>
          {{ dataItem?.name }} -
          <strong
            ><fa-icon
              class="king-icon icon-text"
              [icon]="['fas', 'crown']"
            ></fa-icon
            >{{ dataItem?.kingRestaurantName }}
          </strong></span
        >
      </ng-template>
    </kendo-dropdownlist>
    </kendo-floatinglabel>
    <kendo-floatinglabel text="Combo Type">
    <kendo-dropdownlist
      [data]="comboTypes"
      class="combo-type-dropdown"
      [(ngModel)]="selectedComboType"
      textField="name"
      valueField="id"
      (ngModelChange)="setDefaultState()"
    >
    </kendo-dropdownlist>
    </kendo-floatinglabel>
    <kendo-floatinglabel text="Component Type">
      <kendo-dropdownlist
        [data]="componentTypes"
        class="component-type-dropdown"
        [(ngModel)]="selectedComponentType"
        textField="name"
        valueField="id"
        (ngModelChange)="setDefaultState()"
      >
      </kendo-dropdownlist>
    </kendo-floatinglabel>
    <kendo-floatinglabel text="Exception Type">
      <kendo-dropdownlist
        [data]="exceptionTypes"
        class="exception-type-dropdown"
        [(ngModel)]="selectedExceptionType"
        textField="name"
        valueField="id"
        (ngModelChange)="setDefaultState()"
      >
      </kendo-dropdownlist>
    </kendo-floatinglabel>
  </div>
  <div class="info-section">
    <app-data-grid
    *ngIf="anchorGridData.total > 0"
      [id]="'anchor-grid'"
      [dataItems]="anchorGridData"
      [columns]="anchorColumns"
      [state]="anchorState"
      [fontSize]="fontSize"
      [paginate]="false"
      [filterable]="false"
      [scrollable]="'none'"
    ></app-data-grid>

    <!-- Pricing Legend -->
    <div class="pricing-legend-container">
      <table class="pricing-legend-table">
        <thead>
          <tr>
            <th *ngFor="let item of pricingLegend" [style.background-color]="item.color">
              {{ item.label }}
            </th>
          </tr>
        </thead>
      </table>
    </div>
  </div>
  <div class="buttons-section">
    <button
      kendoButton
      *ngIf="
        substitutionExceptions &&
        substitutionExceptions.data.length > 0 &&
        state.filter &&
        state.filter.filters &&
        state.filter.filters.length > 0
      "
      (click)="fixSubstitutionExceptions()"
      themeColor="success"
      fillMode="solid"
      size="small"
    >
      Fix Exceptions
    </button>
    <app-grid-manager-toolbar
      [showConfig]="false"
      (exportToExcel)="exportExceptions()"
      [fontSize]="fontSize"
      (fontSizeChange)="onFontSizeChange($event)"
      [columns]="columns"
      [view]="'Substitution Exceptions'"
      [showImport]="[]"
      [showExport]="['Current Type']"
    ></app-grid-manager-toolbar>
  </div>
</div>


<app-data-grid
  [group]="group"
  [dataItems]="substitutionExceptions"
  [columnGroups]="columnGroups"
  [columns]="columns"
  [state]="state"
  (dataStateChange)="onDataStateChanged($event)"
  (filterChange)="filterChanged($event)"
  [filterable]="'menu'"
  [fontSize]="fontSize"
>
  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="parItemId"
  >
    <app-custom-filter
      [view]="customFilterView"
      [lazy]="false"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="itemName"
  >
    <app-custom-filter
      [view]="customFilterView"
      [lazy]="false"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template #conditionalFormattingTemplate let-column="column" let-row="row">
    <app-column
      [fontSize]="fontSize"
      [column]="column"
      [data]="row"
      [cellStyle]="{
        'background-color': getCellBackgroundColor(row, column.field),
      }"
    >
    </app-column>
  </ng-template>
</app-data-grid>

